module.exports = "/_next/static/images/39ce0f15dd8cfea3c3349484ab00c619-credit-phase-5.svg.webp";